import React, { useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { LockOutlined } from "@ant-design/icons";
import { Badge, Button, Modal, Space, Tooltip } from "antd";
import { navigate } from "@/Components/Common/NavigationMenu";
import Pricing from "@/Pages/Pricing/Pricing";
import { ProfileContext } from "../../Context/ProfileContext";

export function PremiumBadge({ children }) {
  const { profileData } = useContext(ProfileContext);
  const { t } = useTranslation();

  if (profileData?.recurringPlanType !== "Free") {
    return <div>{children}</div>;
  } else {
    return <Badge color="error">{t("common.Premium.Premium")}</Badge>;
  }
}

export function PremiumButton({
  children,
  title,
  subTitle,
  unlockTitle,
  isWrappedWithinButton = true,
  redirectToPricing = false,
  type,
  priceConfig,
}) {
  const [activePremiumModal, setActivePremiumModal] = useState(false);
  const { profileData } = useContext(ProfileContext);
  const setNavigate = navigate();
  const { t } = useTranslation();
  const defaultPriceConfig =
    profileData?.recurringPlanType === "Free"
      ? ["Free", "Premium", "Annual"]
      : ["Free", "Pro-Monthly", "Pro-Yearly"];

  const handleUnlockClick = useCallback(() => {
    if (redirectToPricing) setNavigate("/pricing");
    else setActivePremiumModal(!activePremiumModal);
  }, [activePremiumModal]);

  const ButtonContent = () => (
    <React.Fragment>
      {isWrappedWithinButton ? (
        <Button icon={<LockOutlined />} onClick={handleUnlockClick}>
          {t("common.Premium.Unlock")} {unlockTitle}
        </Button>
      ) : (
        <span onClick={handleUnlockClick} style={{ cursor: "pointer" }}>
          <Space align="center">
            <LockOutlined />
            {t("common.Premium.Unlock")} {unlockTitle}
          </Space>
        </span>
      )}
    </React.Fragment>
  );

  const renderUnlockComponent = ({ pricingConfig }) => (
    <React.Fragment>
      <Tooltip title={`${priceConfig?.includes("Pro-Yearly") ? "Pro" : "Premium"} Plan`}>
        <ButtonContent />
      </Tooltip>
      <Modal width={800} title={null} open={activePremiumModal} onCancel={handleUnlockClick} footer={null}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Pricing
            hasBillingButton={true}
            title={title ? title : t("common.Premium.Unlock Premium features!")}
            config={pricingConfig}
          />
        </Space>
      </Modal>
    </React.Fragment>
  );

  // Improved logic for showing the icon or label
  if (type && profileData?.featureData) {
    if (profileData?.featureData?.[type] === "false" || !profileData?.featureData?.[type]) {
      return renderUnlockComponent({ pricingConfig: { plans: priceConfig || defaultPriceConfig } });
    }
    return <div>{children}</div>;
  } else if (profileData?.recurringPlanType === "Free") {
    return renderUnlockComponent({ pricingConfig: { plans: priceConfig || defaultPriceConfig } });
  } else return <div>{children}</div>;
}
